export const RegisterElbowSupport = (stateManager) => {
    stateManager.isElbowConnectionAllowed = () => {
        return false;
    };
};
//# sourceMappingURL=registerElbowSupport.js.map